import { StringField } from "../../../types/types";

import {
  TCustomHtmlComponentProps,
  TCustomHtmlComponentFields,
} from "../types/CustomHtmlComponent.type";
import mock from "../../../mocks/CustomHtmlComponent.mock";

export class CustomHtmlComponentModel {
  private readonly fields: null | TCustomHtmlComponentFields;

  constructor(props: TCustomHtmlComponentProps) {
    this.fields = props.fields || null;
  }

  get getInnerHtml(): StringField {
    return this.fields?.["Custom HTML"] ?? mock.fields["Custom HTML"];
  }
}
